import React from 'react'
import ButtonBase from '@mui/material/ButtonBase';
// import Container from '@mui/material/Container';
import { Button, Grid, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import MenuButton from '../components/MenuButton';

// const useStyles = makeStyles({
//     button: {shadowColor:'#EA77BB',
//         elevation:1,
//         backgroundColor: '#EB3581',
//         height : 90 ,
//         width : 200 ,
//         flexDirection: 'row',
//         borderRadius: 20,
//         justifyContent: 'center',
//         alignItems: 'center',
//         marginTop: 35},
//     text: {
//       textTransform: 'capitalize',
//     },
//   });

const CustomButton = styled(Button)({
    background: 'linear-gradient(#E91E63,#1F021C)', // Pink color
  color: 'white',
  fontWeight: 'bold',
  textTransform: 'none',
  width: '80%', 
  maxWidth:250,
  margin: '10px 0',
  borderRadius: '20px',
  textShadow: '0px 4px 6px rgba(0, 0, 0, 0.4)',
  boxShadow: '0px 10px 15px -7px rgba(255, 105, 135, 0.6)', // Bottom glow
  '&:hover': {
    backgroundColor: '#D81B60',
    },
});

const Container = styled(Box)({
    display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  background: 'radial-gradient(circle at top left, rgba(234, 61, 255, 0.4), rgba(0, 0, 0, 0) 40%), radial-gradient(circle at bottom right, rgba(234, 61, 255, 0.4), rgba(0, 0, 0, 0) 40%), #000000',
  flexDirection: 'column',
});

const MainPage = () => {
    // const classes = useStyles();
    const navigate = useNavigate();
    return (
        <div>
            <MenuButton
            showLogin={true}
            showAccount={true}
            showDownload={true}
            // showRestart={true}
            // showChangeAccessories={true}
            // showQuitGame={true}
            // onRestartClick={2}
            // onChangeAccessoriesClick={2}
            // onQuitGameClick={2}
            />
            <Container>
                {/* <CustomButton>Explore</CustomButton> */}
                <CustomButton onClick={() => navigate("/contestants")} >Play & Drink</CustomButton>
                <CustomButton onClick={() => navigate("/rules")}>Rules</CustomButton>
                <CustomButton onClick={() => navigate("/about")}>About</CustomButton>
            </Container>
            {/* <Container component="section" sx={{ mt: 8, mb: 4 }}>
                <Typography variant="OnePirateTypography-markedH4Center" marked="center" align="center" component="h1" style={{}}>
                    Deeper
                    <br></br>
                    For all tastes and all desires
                    <span style={{ height: 4, width: 55, display: 'block', margin: 'auto', marginTop: '10px', backgroundColor: '#FA2F13' }}></span>
                </Typography>

            </Container>
            <Grid
                container
                spacing={2}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid item xs={3}>
                <Button onClick={() => navigate("/contestants")}>
                Play
                </Button>
                </Grid>
                <Grid item xs={3}>
                <Button onClick={() => navigate("/settingspage")}>
                Setting
                </Button>
                </Grid>
                <Grid item xs={3}>
                <Button onClick={() => navigate("/about")}>
                About
                </Button>
                </Grid>
            </Grid> */}
        </div>
    )
}


export default MainPage